import { CommonRouter } from '@primeit/components-vue';

CommonRouter.registerRoutes([
  {
    component: () => import(/* webpackChunkName: "app.onboarding" */ './Onboarding.vue'),
    meta: {
      visible: false,
    },
    path: '/onboarding/:permalink',
  },
]);
